import 'jquery-ui-dist/jquery-ui.min';

var faqFilter = {};

(function (faqFilterApp) {
	var filterModel = {
		Category: null,
		SearchTerm: null
	};
	var fromPopState = false;
	var blockPopstateEvent = true;
	var browserSupportsHistoryApi = window.history && 'pushState' in window.history;

	if (browserSupportsHistoryApi) {
		// prevent Chrome from calling onpopstate on initial load
		$(window).on('load', function () {
			// The timeout ensures that popstate-events will be unblocked right
			// after the load event occured, but not in the same event-loop cycle.
			setTimeout(function () { blockPopstateEvent = false; }, 0);
		});

		$(window).on('popstate', function () {
			if (blockPopstateEvent && document.readyState === "complete") {
				return;
			}
			fromPopState = true;
			performSearchFromUrl();
		});
	}

	function pushHistory() {
		if (browserSupportsHistoryApi && !fromPopState) {
			var currentPath = window.location.pathname;
			var query = "?";
			var queryArray = [];
			if (filterModel.Category) {
				queryArray.push("category=" + filterModel.Category);
			}
			if (filterModel.SearchTerm) {
				queryArray.push("search=" + filterModel.SearchTerm);
			}
			query += queryArray.join("&");
			history.pushState(null, null, currentPath + query);
		}
		fromPopState = false;
	}

	function performSearchFromUrl() {
		filterModel.Category = null;
		filterModel.SearchTerm = null;
		if (window.location.search.length > 1) {
			for (var aItKey, nKeyId = 0, aCouples = window.location.search.substr(1).split("&");
				nKeyId < aCouples.length;
				nKeyId++) {
				aItKey = aCouples[nKeyId].split("=");
				if (aItKey.length <= 1)
					continue;
				var key = decodeURIComponent(aItKey[0]).toLowerCase();
				var val = decodeURIComponent(aItKey[1]);

				if (key === "category") {
					filterModel.Category = val;
				}
				if (key === "search") {
					filterModel.SearchTerm = val;
				}
			}
		}
		faqFilter.GetFaqs();
		setInputFieldsByFilterModel();
	}

	function reinitializeAccordion() {
		$(".accordion").accordion({
			collapsible: true,
			active: false,
			heightStyle: "content"
		});
	}

	function setInputFieldsByFilterModel() {
		var category = filterModel.Category === null || filterModel.Category === "" ? $(".js-category-filter").data("default-category") : filterModel.Category;
		$(".js-category-filter").val(category);
		$(".js-faq-search-field").val(filterModel.SearchTerm);
	}

	faqFilterApp.GetFaqs = function () {
		$.ajax({
			url: "/umbraco/surface/GransRemedyFaqSurface/GetFilterResult",
			type: "GET",
			data: filterModel,
			dataType: "html",
			success: function (data) {
				$(".js-faq-filter-results").html(data);
				reinitializeAccordion();
				pushHistory();
			},
			error: function (error) {
				console.log(error);
			}
		});
	};

	faqFilterApp.setInputValue = function () {
		$(".js-faq-search-field").val(filterModel.SearchTerm);
	}

	$(document).ready(function () {
		//Get url params on load
		const urlParams = new URLSearchParams(window.location.search);

		//check if querystring params exist on load/reload
		if (urlParams.get('category'))
			filterModel.Category = urlParams.get('category');

		if (urlParams.get('search')) {
			filterModel.SearchTerm = urlParams.get('search');
			faqFilter.setInputValue();
		}


		//on dropdown change events
		$(".js-category-filter").change(function () {
			filterModel.Category = this.value;
			faqFilter.GetFaqs();
		});

		//on enter keypress
		$(".js-faq-search-field").on('keypress', function (e) {
			var code = e.keyCode || e.which;
			if (code === 13) {
				filterModel.SearchTerm = this.value;
				filterModel.Category = $('#tags option:selected').val();
				faqFilter.GetFaqs();
			}
		});

		$(".js-faq-search-field-button").on('click', function () {
			filterModel.SearchTerm = $('#faq-search-field').val();
			filterModel.Category = $('#tags option:selected').val();
			faqFilter.GetFaqs();
		});
	});

})(faqFilter);
